export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative rounded-3xl overflow-hidden mb-12">
          <div className="aspect-[16/7] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20artistic%20product%20photography%20flat%20lay%20featuring%20diverse%20fashion%20items%20sneakers%20hoodies%20bags%20caps%20and%20accessories%20beautifully%20arranged%20on%20a%20warm%20cream%20textured%20surface%20with%20natural%20window%20light%20casting%20soft%20delicate%20shadows%20editorial%20lifestyle%20composition%20with%20muted%20earthy%20tones%20sage%20olive%20beige%20and%20warm%20taupe%20creating%20a%20calm%20sophisticated%20atmosphere%20high%20end%20magazine%20quality&width=1400&height=612&seq=cta-flatlay-2026&orientation=landscape"
              alt="CSSBuy Spreadsheet product collection showcase"
              title="CSSBuy Spreadsheet Best Finds Collection"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
        </div>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-8">
          Ready to explore the
          <br />
          <span className="italic font-semibold text-foreground-600">CSSBuy Spreadsheet</span>?
        </h2>
        <p className="text-foreground-600 text-base md:text-lg max-w-xl mx-auto mb-10">
          Access all categories directly on <strong>kaspreadsheet.com</strong> &mdash; the
          best place to browse the complete spreadsheet with live links and daily updates.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-10 py-4 rounded-full bg-foreground-950 text-white font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            cssbuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-10 py-4 rounded-full bg-foreground-950 text-white font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            buy it now
            <span className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}